import { type FileUIPart, isFileUIPart } from "ai";

/** Formats, size and count core accepts for photos sent to tessa */
export const CHAT_PHOTO_TYPES = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/heic",
  "image/heif"
];
export const MAX_CHAT_PHOTOS = 4;
export const MAX_CHAT_PHOTO_BYTES = 5 * 1024 * 1024;

/** Why the files can't be added to the photos already picked, or null when they can */
export const chatPhotosError = (
  files: File[],
  pickedCount: number
): string | null => {
  if (files.some((file) => !CHAT_PHOTO_TYPES.includes(file.type))) {
    return "Photos must be JPEG, PNG, WebP or HEIC.";
  }
  if (files.some((file) => file.size > MAX_CHAT_PHOTO_BYTES)) {
    return "Photos must be 5 MB or smaller.";
  }
  if (pickedCount + files.length > MAX_CHAT_PHOTOS) {
    return `You can send up to ${MAX_CHAT_PHOTOS} photos at a time.`;
  }
  return null;
};

/** The photo as a data URL file part, the way the AI SDK sends files */
export const readChatPhoto = (file: File): Promise<FileUIPart> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () =>
      resolve({
        type: "file",
        mediaType: file.type,
        filename: file.name,
        url: String(reader.result)
      });
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });

export const isPhotoPart = (part: { type: string }): part is FileUIPart =>
  isFileUIPart(part as never) &&
  (part as FileUIPart).mediaType.startsWith("image/");
